<template>
  <Photos :is-new-photos="true" />
</template>

<script lang="ts" setup>
import Photos from '@pages/images/photos/Photos.vue';
</script>

<style lang="scss" scoped>
</style>
